import { Colors } from '~/themes/colors';

export const AlertCircleIcon = ({ color = Colors.error_500 }: any) => (
  <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6465 11.9999C21.6465 17.3018 17.3421 21.5999 12.0324 21.5999C6.72261 21.5999 2.41821 17.3018 2.41821 11.9999C2.41821 6.69797 6.72261 2.3999 12.0324 2.3999C17.3421 2.3999 21.6465 6.69797 21.6465 11.9999ZM13.2341 16.7999C13.2341 17.4626 12.6961 17.9999 12.0324 17.9999C11.3686 17.9999 10.8306 17.4626 10.8306 16.7999C10.8306 16.1372 11.3686 15.5999 12.0324 15.5999C12.6961 15.5999 13.2341 16.1372 13.2341 16.7999ZM12.0324 5.9999C11.3686 5.9999 10.8306 6.53716 10.8306 7.1999V11.9999C10.8306 12.6626 11.3686 13.1999 12.0324 13.1999C12.6961 13.1999 13.2341 12.6626 13.2341 11.9999V7.1999C13.2341 6.53716 12.6961 5.9999 12.0324 5.9999Z"
      fill={color}
    />
  </svg>
);
